import styled, { css } from 'styled-components';

import { Text, Button } from '@gympass/yoga';

import { HeaderButtonProps } from './types';

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
`;

export const HeaderTitle = styled(Text.H4)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const HeaderWelcomeText = styled(Text.Medium)`
  color: ${({ theme }) => theme.yoga.colors.primaryLight};
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const HeaderAmountInfo = styled(Text.H3)`
  color: ${({ theme }) => theme.yoga.colors.primaryLight};
`;

export const HeaderTabActions = styled.div`
  ${({ theme }) => css`
    padding-top: ${theme.yoga.spacing.large}px;

    display: flex;
    align-items: center;
    gap: ${theme.yoga.spacing.medium}px;
  `}
`;

export const HeaderUsersAmount = styled(Text.H3)`
  color: ${({ theme }) => theme.yoga.colors.primaryLight};
`;

export const HeaderUsersText = styled(Text.Medium)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
  color: ${({ theme }) => theme.yoga.colors.primaryLight};
`;

export const HeaderButton = styled(Button)<HeaderButtonProps>`
  ${({ theme, isActive = false }) => css`
    display: flex;
    flex-direction: column;
    height: 88px;
    border-radius: ${theme.yoga.radii.small}px;
    background-color: ${theme.yoga.colors.white};

    ${isActive &&
    css`
      background-color: ${theme.yoga.colors.primaryLight};

      ${HeaderUsersAmount} {
        color: ${theme.yoga.colors.white};
      }

      ${HeaderUsersText} {
        color: ${theme.yoga.colors.white};
      }
    `}
  `}
`;
